<template>
  <div>
    <div class="bg-gps">
      <div class="container">
        <div class="text-center text-white py-5">
          <h1>GPS-треки</h1>
          <hr class="space space-md">
        </div>
      </div>
    </div>
    <hr class="space space-sm">
    <div class="container">
      <div class="card bg-light mb-3">
        <div class="card-body">
          <h4>Как открыть GPS-трек:</h4>
          <ul>
            <li><strong>На телефоне:</strong> приложения для GPS-навигации, такие как Google Maps, Mapy</li>
            <li><strong>На компьютере:</strong> Google Earth</li>
          </ul>
          <p class="mb-0">Чтобы открыть файл GPS-трека, скачайте его и откройте в приложении или импортируйте в приложение. После открытия файла вы сможете просмотреть трек на карте.</p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="list-group">
            <a href="https://zabugorshiki.com/gps/Altyn_Emel_Bashi_Aktau_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Алтын Эмель (Басши-Катутау-Актау)
            </a>
            <a href="https://zabugorshiki.com/gps/Altyn_Emel_Bashi_Barhan_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Алтын Эмель (Актау-Поющий Бархан)
            </a>
            <a href="https://zabugorshiki.com/gps/Big_Almaty_Peak_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Большой Алматинский Пик (через БАО <sup class="text-danger">new</sup>)
            </a>
            <a href="https://zabugorshiki.com/gps/big_almaty_peak_via_terra_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Большой Алматинский Пик (через Поляну Терра)
            </a>
            <a href="https://zabugorshiki.com/gps/Bukreyev_peak_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Букреева
            </a>
            <a href="https://zabugorshiki.com/gps/butakovka_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Бутаковские водопады
            </a>
            <a href="https://zabugorshiki.com/gps/wolf_peak_zabugorshiki.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Волчья гора
            </a>
            <a href="https://zabugorshiki.com/gps/vertoletnaya_ploshadka.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Вертолетная площадка
            </a>
            <a href="https://zabugorshiki.com/gps/Gorelnik_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Горельник
            </a>
            <a href="https://zabugorshiki.com/gps/Kairakskiy_vodopad_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️Кайракский водопад (Тургеньское ущелье <sup class="text-danger">new</sup>)
            </a>
            <a href="https://zabugorshiki.com/gps/kaskabas_zabugorshiki.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Каскабас
            </a>
            <a href="https://zabugorshiki.com/gps/kastek_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Кастек
            </a>
            <a href="https://zabugorshiki.com/gps/kok_zhailyau_zabugorshiki.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Кок-Жайляу через Просвещенца
            </a>
            <a href="https://zabugorshiki.com/gps/kok_zhailyau2_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Кок-Жайляу через Казачье ущелье
            </a>
            <a href="https://zabugorshiki.com/gps/komsomol_part_1_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Комсомола ч.1
            </a>
            <a href="https://zabugorshiki.com/gps/komsomol_part_2_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Комсомола ч.2
            </a>
            <a href="https://zabugorshiki.com/gps/Boguty_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Красные горы Богуты
            </a>
            <a href="https://zabugorshiki.com/gps/bear_waterfall_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Медвежий водопад
            </a>
            <a href="https://zabugorshiki.com/gps/mega_pohod_zabugorshiki.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Мега-поход 1 (Мынжилки - пик Память - Озера Титова - пик Кумбель - Кок-Жайляу)
            </a>
            <a href="https://zabugorshiki.com/gps/megapohod2_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Мега-поход 2 (Пик Молодежный через ущелье Кумбельсу)
            </a>
            <a href="https://zabugorshiki.com/gps/Titov_Peak_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Мега-поход 3 (Пик Титова <sup class="text-danger">new</sup>)
            </a>
            <a href="https://zabugorshiki.com/gps/Medeo_Almatau_zabugorshiki.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Медео-Алматау
            </a>
            <a href="https://zabugorshiki.com/gps/Manshuk_Mametova_lake_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Озеро Маншук Маметовой
            </a>
            <a href="https://zabugorshiki.com/gps/terra_gps_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Поляна Терра
            </a>
            <a href="https://zabugorshiki.com/gps/rakhat_emshek_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Рахат и Емщек
            </a>
            <a href="https://zabugorshiki.com/gps/serkebay_gps_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Серкебай
            </a>
            <a href="https://zabugorshiki.com/gps/borovoe_sinyuha_zabugorshiki.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Синюха (Боровое)
            </a>
            <a href="https://zabugorshiki.com/gps/furnanovka_panorama_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Фурманова-Панорама (лето)
            </a>
            <a href="https://zabugorshiki.com/gps/furmanova_panorama_2_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Фурманова-Панорама (весна)
            </a>
            <a href="https://zabugorshiki.com/gps/Japanese_road_zabugorshiki_com.gpx" class="list-group-item list-group-item-action" target="_blank">
              🏔️ Японская дорога
            </a>
          </div>
          <hr class="space">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tracks',
  data () {
    return {
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>